var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total-stat"},[_c('div',{staticClass:"total-stat-count"},[_c('span',{class:_vm.alertType},[_vm._v(_vm._s(_vm.kpiFormat(_vm.averageRingTime, 'number')))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total-stat-description"},[_vm._v(_vm._s(_vm.$t('averageRingTime')))])
}]

export { render, staticRenderFns }